/**
 * @fileoverview Plan Centro de Costo collection type definitions
 * Generated from model.json structure
 * Used for production task planning with ordered cost center sequences
 */

import type { SoftDeletableRecord } from '../common/PocketBaseTypes';
import type { CentroCostoPesoExpanded } from './CentroCostoPeso';

/**
 * Plan Centro de Costo interface based on PocketBase model.json
 * Collection ID: pbc_869142999
 * Used for production task planning with ordered cost center sequences
 */
export interface PlanCentroCosto extends SoftDeletableRecord {
  /** Nombre del plan de trabajo */
  nombre?: string;
  /** Array de IDs de centro_costo_peso (relación múltiple) */
  centro_costo_peso?: string[];
  /** Datos expandidos de relaciones */
  expand?: {
    /** Array de centros de costo con peso expandidos */
    centro_costo_peso?: CentroCostoPesoExpanded[];
  };
}

/**
 * Expanded Plan Centro de Costo interface for when relations are expanded
 * Used when PocketBase returns expanded data with full objects instead of IDs
 */
export interface PlanCentroCostoExpanded extends SoftDeletableRecord {
  /** Nombre del plan de trabajo */
  nombre?: string;
  /** Array de centros de costo con peso expandidos */
  centro_costo_peso?: CentroCostoPesoExpanded[];
}

/**
 * Type for creating new Plan Centro de Costo records
 * Omits system fields that are auto-generated
 */
export type CreatePlanCentroCostoData = Omit<PlanCentroCosto, 'id' | 'created' | 'updated'>;

/**
 * Type for updating Plan Centro de Costo records
 * All fields are optional except system fields
 */
export type UpdatePlanCentroCostoData = Partial<CreatePlanCentroCostoData>;

/**
 * Collection metadata for Plan Centro de Costo
 */
export const PLAN_CENTRO_COSTO_COLLECTION = {
  name: 'plan_centro_costo',
  id: 'pbc_869142999',
  type: 'base',
  system: false,
  indexes: [], // No custom indexes defined in model.json
  rules: {
    list: 'admin || supervisor',
    view: 'authenticated',
    create: 'admin || supervisor',
    update: 'admin || supervisor',
    delete: null
  }
} as const;
